var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"month-event"},[_c('div',{staticClass:"title"},[_vm._v("\n    "+_vm._s(_vm.title)+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"count"},[_vm._v("\n    "+_vm._s(_vm.count)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }